// radioボタンが変更されたらフォーム送信 /education/news/
document.addEventListener('DOMContentLoaded', function () {
	const form = document.getElementById('filter-form');
	const radioButtons = form.querySelectorAll('input[type="radio"]');
	console.log(radioButtons);

	radioButtons.forEach(function (radio) {
		radio.addEventListener('change', function () {
			form.submit();
		});
	});
});
